import i18n from "@/config/i18n";
import { ExtraResponse } from "../api/ExtraResponse";

export class Extra {
	identifier: string;
	description: string;
	resourceCode: string;
	type: string;
	maxBookable?: number;
	disabled: boolean;
	route?: string;
	notBookableMessage?: string;

	constructor(resp: ExtraResponse) {
		this.description = i18n.global.t(`extras.resources.description.${resp.resourceCode}`);
		this.route = resp.route;
		this.identifier = resp.identifier;
		this.resourceCode = resp.resourceCode;
		this.disabled = resp.bookable === true ? false : true;
		this.type = resp.type;
		this.notBookableMessage = resp.notBookableMessage;
		this.maxBookable = (resp.maxBookable ?? 0) > 0 ? resp.maxBookable : 9 //default value if maxbookable isn't set;
	}
}